import vero from "../../../../assets/images/logo-vibe-vero.png";
import "./Footer.scss";

const Footer = () => {
  return (
    <>
      <div className="redemption-footer">
        <div>
          <div className="redemption-footer-logo col-sm">
            <img src={vero} alt="vero" width="183px" height="24px" />
          </div>
          <p>Caso tenha dúvidas, entre em contato com a gente.</p>
          <a
            target="_blank"
            href="https://wa.me/+551135048336"
            rel="noreferrer"
            className="contact-us"
          >
            Fale conosco
          </a>
        </div>

        <div className="footer-line row"></div>
        <div className="footer-address row">
          <span>
            Alameda Rio Negro, 585, 13º Andar. Alphaville, Barueri, SP. CEP
            06454-000.
          </span>
          <div className="footer-links">
            <a
              target="_blank"
              href="https://creditosvibe.com.br/politica-de-privacidade/"
            >
              Política de Privacidade
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
